import React, { useState, useEffect, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import ApiService from '../../services/apiService';

const LocationMasterGrid = ({ rowData, getLocation, canEditMaster, setSelectedRow, handleEdit }) => {

    const columnDefs = [
        { headerCheckboxSelection: true, checkboxSelection: true, headerCheckboxSelectionFilteredOnly: true, suppressMovable: true, width: 45 },
        { headerName: 'Record ID', field: 'recordId',  headerCheckboxSelectionFilteredOnly: true, suppressMovable: true, minWidth: 390 },
        { headerName: 'Location', field: 'description',  headerCheckboxSelectionFilteredOnly: true, suppressMovable: true, minWidth: 390 },
        { headerName: 'Category', field: 'location',  headerCheckboxSelectionFilteredOnly: true, suppressMovable: true, minWidth: 390 },
        {
            headerName: 'Status', field: 'exp3', cellRenderer: BtnCellRenderer, minWidth: 390, headerCheckboxSelectionFilteredOnly: true, suppressMovable: true,
            cellRendererParams: {
                canEditMaster: canEditMaster,
                clicked: function (field, exp3) {
                    handleToggle(field, exp3);
                },
            },
        }
    ];
    const updateActiveStatus = async (id, isActive) => {
        try {
            const apiService = new ApiService();
            
            let body = {
                recordId: id,
                exp3: isActive === true ? "1" : "0"
            }
            const res = await apiService.put(`UPDATE_WAREHOUSE_MASTER`, body);
            if (res?.status === 200) {
                getLocation();
            } else {
                console.error('Failed to update');
            }
        } catch (error) {
            console.error('Error updating item:', error);
        }
    };
    const onCellClicked = (event) => {
        if (event.colDef.field === 'recordId') {
            setSelectedRow(null);
            const clickedRowData = event.data;
            setSelectedRow(clickedRowData);
            handleEdit(clickedRowData)
        }
    };
    const onSelectionChanged = (event) => {
        const selectedRows = event.api.getSelectedRows();
        setSelectedRow(selectedRows.length === 1 ? selectedRows[0] : null);
    };
    const handleToggle = (recordId, newExp9Value) => {
        updateActiveStatus(recordId, newExp9Value === "1");
    };
    return (
        <div className='gridshad' style={{ height: 550 }}>
            <div className="ag-theme-quartz" style={{ height: 550 }}>
                <AgGridReact
                    getRowStyle={(params) => {
                        if (params.node.rowIndex % 2 === 0) {
                            return { background: '#F0EDF5' };
                        } else {
                            return { background: '#fff' };
                        }
                    }}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    onCellClicked={onCellClicked}
                    onSelectionChanged={onSelectionChanged}
                />
            </div>
        </div>
    );
};

class BtnCellRenderer extends Component {

    constructor(props) {
        super(props);
        this.btnClickedHandler = this.btnClickedHandler.bind(this);
    }

    btnClickedHandler() {
        const { value, clicked, data } = this.props;
        const exp3 = data.exp3 === "1" ? "0" : "1";
        clicked(data.recordId, exp3);
    }

    render() {
        const { exp3 } = this.props.data;
        const { canEditMaster } = this.props;
        return (
            <div className='d-flex'>
                {canEditMaster === true ?
                    <div className="form-check form-switch center">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id={`flexSwitchCheck`}
                            checked={exp3 === "1"}
                            onClick={this.btnClickedHandler}
                        />
                    </div>
                    :
                    <div className="form-check form-switch center">
                        <input disabled
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id={`flexSwitchCheck`}
                            checked={exp3 === "1"}
                        />
                    </div>
                }
            </div>
        )
    }
}
export default LocationMasterGrid;
